import React, { useEffect, useState } from 'react';

import { Divider, Grid, Typography } from '@mui/material';

import {
    Text,
    Button,
    Select,
    Switch,
    Tabs,
    Documents,
    Combo,
    Document,
    DataGridPro as DataGrid
} from 'core/components';

import * as enums from 'core/enums';
import * as icons from 'core/icons';
import List from '../../../../../../store/List';

import { statesEntity } from 'core/enums';
import { ENTITY_EXPLOTACION_BODEGA } from '../../../../../../store/entities/constants';
import DetailMarca from 'views/maestros/Etiquetas/Detalle';
import { DateTime } from 'luxon';
import * as helpers from '../../../../../../core/helpers';

const ComboTipoVino = List(Combo, 'options', 'lsttipovino');
const ComboEnvase = List(Combo, 'options', 'lstenvases');
const ComboMarca = List(Combo, 'options', 'lstmarcas');

let timeBoxCodigo = 0;

const cols = (name, row, index, editing, handleChange, values) => [
    {
        key: 'tipoVino',
        title: 'Tipo Vino',
        align: 'left',
        width: '15%',
        component: row && (
            <ComboTipoVino
                fullWidth
                variant='standard'
                api='auxiliares/variedadesvino/'
                name='tipoVino'
                nameKey='tipoVinoId'
                Icon={icons.WineIcon}
                value={row.tipoVino}
                onChange={
                    handleChange &&
                    (values => handleChange(values, name, index))
                }
                editing={editing}
                propertyValue='id'
                getOptionLabel={option => option.descripcion}
                searchKeys={['descripcion']}
            />
        )
    },
    !values.numeracion
        ? {
              key: 'bobinado',
              title: 'Bobinado',
              align: 'left',
              width: '14%',
              component: row && (
                  <Select
                      fullWidth
                      editing={editing}
                      name='bobinado'
                      variant='standard'
                      margin='none'
                      options={enums.typeBobinado}
                      value={row.bobinado}
                      onChange={
                          handleChange &&
                          (values => handleChange(values, name, index))
                      }
                  />
              )
          }
        : undefined,
    !values.numeracion
        ? {
              key: 'rollo',
              title: 'Rollo',
              align: 'left',
              width: '14%',
              component: row && (
                  <Select
                      fullWidth
                      editing={editing}
                      name='rollo'
                      variant='standard'
                      margin='none'
                      options={enums.typeRollo}
                      value={row.rollo}
                      onChange={
                          handleChange &&
                          (values => handleChange(values, name, index))
                      }
                  />
              )
          }
        : undefined,
    !values.numeracion
        ? {
              key: 'envase',
              title: 'Envase',
              align: 'left',
              width: '35%',
              component: row && (
                  <ComboEnvase
                      fullWidth
                      variant='standard'
                      api='auxiliares/envases/'
                      name='envase'
                      nameKey='envaseId'
                      Icon={icons.PackageIcon}
                      value={row.envase}
                      onChange={
                          handleChange &&
                          (values => handleChange(values, name, index))
                      }
                      editing={editing}
                      propertyValue='id'
                      getOptionLabel={option => option.descripcion}
                      searchKeys={['descripcion']}
                  />
              )
          }
        : undefined,
    {
        key: 'cantidad',
        title: 'Cantidad',
        align: 'center',
        width: '14%',
        component: row && (
            <Text
                fullWidth
                editing={editing}
                name='cantidad'
                variant='standard'
                margin='none'
                type='d.2'
                value={row.cantidad}
                onFocus={event => event.target.select()}
                onChange={
                    handleChange &&
                    (values => handleChange(values, name, index))
                }
            />
        )
    },
    {
        key: 'añada',
        title: 'Añada',
        align: 'center',
        width: '8%',
        component: row && (
            <Text
                fullWidth
                variant='standard'
                editing={editing}
                name='añada'
                margin='none'
                type='0.4'
                value={row.añada}
                onFocus={event => event.target.select()}
                onChange={
                    handleChange &&
                    (values => handleChange(values, name, index))
                }
            />
        )
    },
    values.numeracion
        ? {
              key: 'etiqueta',
              title: 'Marca / Etiqueta',
              align: 'left',
              width: '35%',
              component: row && (
                  <ComboMarca
                      fullWidth
                      variant='standard'
                      api='etiquetasmarca'
                      name='etiqueta'
                      nameKey='etiquetaId'
                      Icon={icons.ContraetiquetasIcon}
                      value={row.etiqueta}
                      onChange={
                          handleChange &&
                          (values => handleChange(values, name, index))
                      }
                      editing={editing}
                      propertyValue='id'
                      getOptionLabel={option =>
                          `${option.marca.nombre}-[${option.nombre}]`
                      }
                      relacionado={{
                          type: ENTITY_EXPLOTACION_BODEGA,
                          Detail: DetailMarca,
                          resume: ['nombre'],
                          readOnly: false
                      }}
                      searchKeys={['marca.nombre', 'resumen']}
                      filters={[
                          {
                              fields: ['numeracionInsertada'],
                              values: true,
                              operator: '=',
                              type: 'checkbox'
                          },
                          {
                              fields: [['explotacion', 'id']],
                              values: values.explotacion.id,
                              operator: '',
                              type: 'text'
                          }
                      ]}
                  />
              )
          }
        : undefined,
    values.numeracion
        ? {
              key: 'imprenta',
              title: 'Imprenta',
              align: 'left',
              width: '28%',
              component: row && (
                  <Text
                      fullWidth
                      variant='standard'
                      editing={editing}
                      name='imprenta'
                      margin='none'
                      value={row.imprenta}
                      onFocus={event => event.target.select()}
                      onChange={
                          handleChange &&
                          (values => handleChange(values, name, index))
                      }
                  />
              )
          }
        : undefined
];

const Contraetiquetas = props => {
    const {
        values,
        editing,
        handleChange,
        handleError,
        refresh,
        execAction,
        reload
    } = props;

    const [cantidadTotal, setCantidadTotal] = useState(0);

    useEffect(() => {
        calculaTotales();
    }, [JSON.stringify(values.detalleAlmacenamiento)]);

    const calculaTotales = () => {
        let newCantidadTotal = 0;

        if (values && values.detalleAlmacenamiento) {
            values.detalleAlmacenamiento.forEach(detalle => {
                newCantidadTotal += Number(detalle.cantidad);
            });
        }

        setCantidadTotal(newCantidadTotal);
    };

    const actualizaCodigo = () => {
        if (editing) {
            const action = () => {
                const accion = {
                    api: 'tramites/emcs',
                    metodo: 'post',
                    data: {
                        fields: ['emcs'],
                        values: { ...values }
                    }
                };
                execAction(accion, [reload]);
            };

            timeBoxCodigo > 0 && clearTimeout(timeBoxCodigo);
            timeBoxCodigo = setTimeout(action, 250);
        }
    };

    return (
        <form autoComplete='off' noValidate>
            <Grid container spacing={2}>
                <Grid item xs>
                    <Grid container direction='column' spacing={2}>
                        <Grid item xs>
                            <Grid
                                container
                                justifyContent={'space-around'}
                                alignItems={'center'}
                            >
                                <Grid item>
                                    <Switch
                                        value={values.numeracion}
                                        onChange={handleChange}
                                        name='numeracion'
                                        label='Numeracion'
                                        editing={editing}
                                    />
                                </Grid>
                                <Grid item xs>
                                    <Grid
                                        sx={{
                                            marginTop: '10px',
                                            marginBottom: '10px',
                                            backgroundColor: 'lightgray',
                                            height: 25,
                                            borderRadius: 1
                                        }}
                                        container
                                        justifyContent={'space-around'}
                                        alignItems={'center'}
                                    >
                                        <Grid item>
                                            <Typography variant={'h5'}>
                                                {'Detalles Contraetiquetas'}
                                            </Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant={'h5'}>
                                                {`Cantidad Total: ${helpers.getValueFormatted('d.2', cantidadTotal)}`}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs>
                            <DataGrid
                                name='detalleContraetiquetas'
                                editing={editing}
                                rows={
                                    values.detalleContraetiquetas
                                        ? values.detalleContraetiquetas
                                        : []
                                }
                                cols={(name, row, index) =>
                                    cols(
                                        name,
                                        row,
                                        index,
                                        editing,
                                        handleChange,
                                        values
                                    )
                                }
                                onAdd={name => {
                                    handleChange(
                                        {
                                            linea:
                                                values.detalleContraetiquetas &&
                                                values.detalleContraetiquetas
                                                    .length !== 0
                                                    ? values
                                                          .detalleContraetiquetas[
                                                          values
                                                              .detalleContraetiquetas
                                                              .length - 1
                                                      ].linea + 1
                                                    : 1,
                                            cantidad: 0
                                        },
                                        name
                                    );
                                }}
                                onDelete={(name, index) =>
                                    handleChange(
                                        undefined,
                                        name,
                                        (index + 1) * -1
                                    )
                                }
                                minHeight={350}
                                maxHeight={350}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </form>
    );
};

export default Contraetiquetas;
